module.exports = __webpack_public_path__ + "static/media/Screenshot_1.395b1363.png";